import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "supplier-questions-header";

const keys = addTranslations(RESOURCE_NAME, {
    search: {
        en: "Search question",
        fr: "Rechercher une question",
    },
    answer_type_filter_label: {
        en: "Answer type",
        fr: "Type de réponse",
    },
    questionnaire_filter_label: {
        en: "Questionnaire",
        fr: "Questionnaire",
    },
    question_group_filter_label: {
        en: "Section",
        fr: "Section",
    },
    add_question_btn: {
        en: "Add question",
        fr: "Ajouter une question",
    },
    en: {
        en: "English",
        fr: "Anglais",
    },
    fr: {
        en: "French",
        fr: "Français",
    },
    exportQuestions: {
        en: "Export questions",
        fr: "Exporter les questions",
    },
    import_questions: {
        en: "Import Questions",
        fr: "Importer des questions",
    },
    sort_questions: {
        en: "Sort questions",
        fr: "Trier les questions",
    },
    group_not_translated: {
        en: "Translation not available",
        fr: "Traduction non disponible",
    },
});

export function useSupplierQuestionsHeaderTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return { t, keys };
}
